module.exports = __webpack_public_path__ + "static/gary-ac76cc74d75becad20ce45fe38850b5c.png";